import { render } from "./TaskList.vue?vue&type=template&id=3527ce68"
import script from "../assets/js/tasklist.js?vue&type=script&lang=js"
export * from "../assets/js/tasklist.js?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=3527ce68&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\DWEC\\projects\\ToDoList\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__